import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import moment from "moment";

export const SEARCH_SLAB_FORM_FIELDS = {
    country: "",
    state: "",
    bu: ""
}

export const CREATE_SLAB_FORM_FIELDS = {
    country: "",
    state: "",
    bu: "",
    buType: "",
    effectiveDate: moment().format("YYYY-MM-DD"),
    status: "INACTIVE",
    slabType: "INVIGILATOR"
}

export const EDIT_SLAB_FORM_FIELDS = {
    status: "INACTIVE",
    effectiveDate: moment().format("YYYY-MM-DD"),
}

export const newRow = {
    minutes: "",
    amount: ""
}

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.country.getAllActive,
            "countryDesc",
            "id",
        ),
        dropdownMapping(
            endpoint.state.getAllActive,
            "stateDispValue",
            "id",
        ),
        dropdownMapping(endpoint?.businessUnitType?.getAllBusinessUnitType, 'businessUnitTypeDispValue', 'id'),

    ]);

    return {
        country: dropdown[0],
        state: dropdown[1],
        buType: dropdown[2]
    }
}


export const searchPaymentSlab = async (payload, offset, limit) => {
    // API expects offset (page number) and limit (page size)
    const url = `${endpoint.vendorPaymentSlab.searchPaymentSlab}?pageNo=${offset}&pageSize=${limit}`;
    const response = await fetchAllPostPromisedData(url, payload);

    return response;
};

export const chipStyle = {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 14px",
    borderRadius: 16,
    background: "#F7F7F7",
    marginLeft: 8,
    fontSize: 14,
    fontWeight: 500,
    color: "#333",
    marginBottom: 8,
};
export const labelStyle = { color: "#AFAFAF", marginRight: 4 };

export const selectStyles = {
    control: {
        borderRadius: '4px',
        height: '32px'
    }
}
export const inputStyles = {
    borderRadius: '4px',
    height: '32px'
}


export const updateSlabDetails = async (slabId, payload) => {
    const response = await fetchAllPostPromisedData(
        `${endpoint.vendorPaymentSlab.operateSlab}/${slabId}/edit`,
        payload,
        "put",
    );
    return response;
};

export const convertMinutesToHHMM = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

export const HHMMToMinutes = (time) => {
    const duration = moment.duration(time);
    return duration.asMinutes();
};

export const minutesToHM = (totalMinutes = 0) => {
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return { hours: h, minutes: m };
};

export const hmToMinutes = (h = 0, m = 0) => {
    return (Number(h) || 0) * 60 + (Number(m) || 0);
};

export const getCreateUpdateReqBody = (rowData) => {
    const { minutes, amount } = rowData;
    return {
        countFrom: minutes,
        amount
    }
}